import React from "react";
import ListMember from "components/Chat/ListMember";
import { find, get, isEmpty } from "lodash";
import Skeleton from "@mui/material/Skeleton";
import withStyles from '@mui/styles/withStyles';

const styles = () => ({
  ChatMemberListWrapper: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    backgroundColor: "white",
  },
  isLoadingListMember: {
    display: "flex",
    alignItems: "center",
    padding: "8px 16px",
    borderBottom: "0.5px solid rgba(0, 0, 0, 0.15)",
  },
});

const getUnreadCountFor = (channelList, channelId) =>
  find(channelList, (channel) => channel.channelId === channelId);

const ChatMemberList = ({
  classes,
  chatChannels,
  myId,
  isLoading,
  onItemClick,
  channelUnreadCount,
  selectedChannelId,
  botUsers,
}) => {
  const isLoadingListMember = (
    <>
      <div className={classes.isLoadingListMember}>
        <Skeleton variant="circular" width={48} height={48} />
        <Skeleton
          animation="wave"
          height={60}
          width="68%"
          style={{ marginLeft: 12 }}
        />
      </div>
      <div className={classes.isLoadingListMember}>
        <Skeleton variant="circular" width={48} height={48} />
        <Skeleton
          animation="wave"
          height={60}
          width="68%"
          style={{ marginLeft: 12 }}
        />
      </div>
    </>
  );

  const filteredChannels = (Array.isArray(chatChannels) ? chatChannels : []).filter(
    (channel) => {
      const channelMembers = channel.channelMembers || [];
      const myMember = channelMembers.find((member) => member.userId === myId);

      const isCurrentUserInactiveInChannel =
        isEmpty(channelMembers) || isEmpty(myMember) || myMember.isActive === false;

      if (isCurrentUserInactiveInChannel) {
        return false;
      }

      if (myMember?.isPairManager) {
        const otherMembersInactive = channelMembers
          .filter((member) => member.userId !== myId)
          .every((member) => !member.isActive);
        return !otherMembersInactive;
      }

      return true;
    }
  );

  const sortedChannels = filteredChannels.sort((a, b) => {
    const aUnread = get(
      getUnreadCountFor(channelUnreadCount, get(a, "channelId")),
      "count",
      0
    );
    const bUnread = get(
      getUnreadCountFor(channelUnreadCount, get(b, "channelId")),
      "count",
      0
    );

    return bUnread - aUnread;
  });

  return (
    <div className={classes.ChatMemberListWrapper}>
      {isLoading
        ? isLoadingListMember
        : sortedChannels.map((channel) => (
            <ListMember
              key={channel.channel_id}
              unreadMessageCount={get(
                getUnreadCountFor(channelUnreadCount, get(channel, "channelId")),
                "count"
              )}
              unreadMessageData={get(
                getUnreadCountFor(channelUnreadCount, get(channel, "channelId")),
                "data"
              )}
              isGroup={get(channel, "isGroup")}
              members={get(channel, "channelMembers")}
              channelName={get(channel, "channelName")}
              onItemClick={onItemClick}
              channelId={get(channel, "channelId", "")}
              isSelected={selectedChannelId === get(channel, "channelId")}
              myId={myId}
              botUsers={botUsers}
            />
          ))}
    </div>
  );
};

export default withStyles(styles)(ChatMemberList);
